import { Component, OnInit } from '@angular/core';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { Manuscript } from '../../../models/manuscript';
import { VocsService } from '../../../services/vocs.service';
import { VocTerms } from '../../../models/voc-term';
import { MsDecorationList } from '../../../models/ms-decoration';
import { MsImageLink, MsImageLinkList } from '../../../models/ms-image-link';
import { MsBindingList } from '../../../models/ms-binding';

@Component({
  selector: 'app-ms-details-other-info',
  templateUrl: './ms-details-other-info.component.html',
  styleUrls: ['./ms-details-other-info.component.css']
})
export class MsDetailsOtherInfoComponent implements OnInit {
    manuscript: Manuscript; // current manuscript data
    writingSupportImageLinks: MsImageLinkList; // writing support image links
    textBlockImageLinks: MsImageLinkList; // text block image links
    handsWritingsImageLinks: MsImageLinkList; // hands writings image links
    inkHeadingsImageLinks: MsImageLinkList; // ink headings image links
    stateOfPreservationImageLinks: MsImageLinkList; // state of preservation image links
    bindings: MsBindingList; // current manuscript bindings
    decorations: MsDecorationList; // current manuscript decorations
    annotationTypesVoc: VocTerms; // vocabulary of image annotation types
    completenessVoc: VocTerms; // vocabulary of completeness states
    writingHandsVoc: VocTerms; // vocabulary of writing hands
    inksVoc: VocTerms; // vocabulary of inks

    constructor(
        private manuscriptsService: ManuscriptsService,
        private vocsService: VocsService
        ) {
    }

    ngOnInit(): void {
        this.manuscriptsService.getManuscript()
            .subscribe(response => this.manuscript = response, err => console.error(err));
        this.manuscriptsService.getWritingSupportImageLinks()
            .subscribe(response => this.writingSupportImageLinks = response, err => console.error(err));
        this.manuscriptsService.getTextBlockImageLinks()
            .subscribe(response => this.textBlockImageLinks = response, err => console.error(err));
        this.manuscriptsService.getHandsWritingsImageLinks()
            .subscribe(response => this.handsWritingsImageLinks = response, err => console.error(err));
        this.manuscriptsService.getInkHeadingsImageLinks()
            .subscribe(response => this.inkHeadingsImageLinks = response, err => console.error(err));
        this.manuscriptsService.getStateOfPreservationImageLinks()
            .subscribe(response => this.stateOfPreservationImageLinks = response, err => console.error(err));
        this.manuscriptsService.getManuscriptBindings()
            .subscribe(response => this.bindings = response, err => console.error(err));
        this.manuscriptsService.getManuscriptDecorations()
            .subscribe(response => this.decorations = response, err => console.error(err));
        this.vocsService.getAnnotationTypes()
            .subscribe(response => this.annotationTypesVoc = response, err => console.error(err));
        this.vocsService.getCompleteness()
            .subscribe(response => this.completenessVoc = response, err => console.error(err));
        this.vocsService.getWritingHands()
            .subscribe(response => this.writingHandsVoc = response, err => console.error(err));
        this.vocsService.getInks()
            .subscribe(response => this.inksVoc = response, err => console.error(err));
    }

    selectImage(imageLink: MsImageLink): void {
        this.manuscriptsService.selectMsImageLink(imageLink);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/ms-details-other-info/ms-details-other-info.component.ts